import React from 'react';
import { ClassValue } from 'classnames/types';
import { CreateProps } from '../../../types/utils/CreateProps';
import Div from '../../Element/Div/Div';
import { SupportedColor } from '../../Element/Element';
import styles from './CheckboxIcon.module.scss';

type CheckboxIconProps = CreateProps<
  {
    /** Color of icon */
    color: SupportedColor;
    /** Additional CSS class for container */
    className?: ClassValue;
    /** Icon name used */
    iconName: 'checkmark' | 'minus';
  },
  typeof Div
>;

const CheckboxIcon: React.FunctionComponent<CheckboxIconProps> = ({
  color,
  className,
  iconName,
  ...props
}) => {
  return (
    <Div color={color} className={[styles.checkboxIcon, className]} {...props}>
      {iconName === 'minus' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 8C1 7.17157 1.67157 6.5 2.5 6.5H13.5C14.3284 6.5 15 7.17157 15 8C15 8.82843 14.3284 9.5 13.5 9.5H2.5C1.67157 9.5 1 8.82843 1 8Z"
          />
        </svg>
      )}
      {iconName === 'checkmark' && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1662 2.56234C14.8221 3.06834 14.9437 4.01028 14.4377 4.66622L8.03501 12.966C7.29827 13.921 5.89013 14.0115 5.03724 13.1586L1.68934 9.81067C1.10355 9.22489 1.10355 8.27514 1.68934 7.68935C2.27513 7.10357 3.22487 7.10357 3.81066 7.68935L6.35435 10.233L12.0623 2.83381C12.5683 2.17787 13.5103 2.05633 14.1662 2.56234Z"
          />
        </svg>
      )}
    </Div>
  );
};

export default CheckboxIcon;
